@if(vm.error) {
<div class="alert alert-danger">
   <p>
      <strong>{{ vm.error.title }}</strong>
   </p>
   <p>{{ vm.error.text }}</p>
</div>
}
